export const WHY_ONEMIND_CONSTANTS = {
  title: "​Certifications & Compliance Standards We Meet​",
  desc: "We don’t just help you stay compliant — we are too. OneMind is committed to upholding global security and data privacy regulations. Our platforms and services are aligned with industry-leading standards, giving you the confidence to build, scale, and operate securely in any environment.",
};
